<ng-container *ngIf="hasFilterAirline">
  <div class="airFilterBarAirlines__cont">
    <ng-container *ngFor="let airline of airlines | orderBy: 'MinPrice'; trackBy: trackById">
      <div class="airFilterBarAirlines__cont__airline">
        <app-ds-floating-filter
          [image]="airline.Image"
          [label]="airline.Label | airlineName"
          [state]="getFloatingFilterState(activeAirline(airline))"
          (clickEvent)="selectAirline(airline)">
        </app-ds-floating-filter>
      </div>
    </ng-container>
  </div>
</ng-container>